import Template from "./template.js";
import Button from "./buttons";

let template = new Template(375, 375, 4);
let buttons = new Button();
if (template.localArr) {
    template.renderLocal();
}
if (!template.localArr || template.localArr.length < 4) {
    template.render();
}
template.renderHeader();
buttons.renderButtons();
buttons.bindEvents();
template.doResArr();
